/**
 * @desc 获取创建参考信息
 */
const URL = "/rantion-wms";
import http, { updateResponse } from "@/http";
export function request(params: API.wms.demandOrder.getCreateBeforeInfo.Params, options?: any) {
  return updateResponse(
    http(URL + `/wms/demandOrder/getCreateReferenceInfo`, {
      method: "GET",
      params,

      ...options,
    }),
  );
}
